import type { PhotoName } from './media';

/**
 * Homepage capability overview.
 * Every description is derived from information already published by the company in this project
 * (seeded About / capabilities content and product data in sas_be/prisma/seed-data.ts).
 * Do not add machinery, volumes, certifications or capabilities here without verification.
 */
export interface Capability {
  title: string;
  description: string;
  photo: PhotoName;
  to: string;
  linkLabel: string;
}

export const CAPABILITIES: Capability[] = [
  {
    title: 'Custom Apparel Manufacturing',
    description: 'Cut-and-sew production in Faisalabad — t-shirts, hoodies, sweatshirts and streetwear in heavy GSM cotton, French terry and fleece.',
    photo: 'garmentWorkshop',
    to: '/apparel',
    linkLabel: 'Apparel catalogue',
  },
  {
    title: 'Sportswear & Teamwear',
    description: 'Dry-fit training kits and fully sublimated team jerseys with names, numbers and crests for clubs, schools and distributors.',
    photo: 'machineThreading',
    to: '/apparel/teamwear',
    linkLabel: 'Teamwear',
  },
  {
    title: 'Football Manufacturing',
    description: 'Thermobonded, machine-stitched and hand-stitched footballs made in Sialkot with your logo and packaging.',
    photo: 'footballGrass',
    to: '/sports-goods/footballs',
    linkLabel: 'Footballs',
  },
  {
    title: 'Cricket Bats & Balls',
    description: 'English and Kashmir willow bats with custom stickers and grips, plus leather hard balls and tennis soft balls.',
    photo: 'cricketBallHand',
    to: '/sports-goods',
    linkLabel: 'Sports goods',
  },
  {
    title: 'Private Label Production',
    description: 'Made to order for your brand only — woven labels, hang tags, polybags, carton marking and export documentation.',
    photo: 'cartonPacking',
    to: '/private-label',
    linkLabel: 'How private label works',
  },
  {
    title: 'Custom Branding & Finishing',
    description: 'In-house decoration: screen print, puff print, DTG, embroidery, chenille and sublimation, applied to your artwork.',
    photo: 'embroidery',
    to: '/private-label',
    linkLabel: 'Branding options',
  },
];
